import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg"
import TerminateSocialSecurityModal from "../reportModal/TerminateSocialSecurityModal";

const TerminateSocialSecurityReportComponent = ({
    pdfUrl,
    showReport,
    showModal = () => { },
    initialValues,
    departmentOptions = [],
    positionOptions = [],
    branchOptions = [],
    isModalOpen = false,
    handleSearch = () => { },
    setIsModalOpen = () => { },
    exportSSOTerminateReport = () => { },
    isDownloading
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            <TerminateSocialSecurityModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                exportSSOTerminateReport={exportSSOTerminateReport}
                isDownloading={isDownloading}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("employee_history_group.header"), href: "" },
                        { title: t("terminate_social_security_report.header") }
                    ]} />
                    <h2>{t("terminate_social_security_report.header")}</h2>
                </Flex>

                <FormAntd
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="branchId"
                                                        label={t('employee.label.branch')}
                                                        options={branchOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        mode="multiple"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="startToEndDate"
                                                        type="range"
                                                        label={t('start-date-to-end-date')}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-date-to-end-date')}
                                                        size="large"
                                                    // onChange={handleDateChange}
                                                    />
                                                </Col>

                                            </Row>


                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>

                                            <iframe
                                                src={pdfUrl}
                                                title="Termination of the Social Security Fund Preview"
                                                width="100%"
                                                height="600px"
                                                style={{
                                                    border: "1px solid #ccc",
                                                    borderRadius: "8px",
                                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                                                }}
                                            />

                                        </Space>
                                    )}
                                </>
                            );
                        }}
                    </FormItem>

                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default TerminateSocialSecurityReportComponent;